module.exports = __webpack_public_path__ + "img/artboard5.f40807fb.png";